import { HotelHomeController } from './hotel-home-controller';
import { InfositeController } from './infosite-controller';
import { SearchController } from './search-controller';
export const hotel = [HotelHomeController, InfositeController, SearchController];